import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { IProjectStageDto } from "src/models/new-dwelling/new-dwelling.model";
import { NewDwellingListExportService } from "src/services/new-dwellings/new-dwelling-list-export.service";
import { RightSidebarOptions, RightSidebarService } from "src/services/right-sidebar.service";
import { EvLogoLoaderComponent } from "src/app/shared-components/ev-logo-loader/ev-logo-loader.component";

@Component({
    selector: "new-dwelling-lists",
    imports: [EvLogoLoaderComponent],
    providers: [NewDwellingListExportService],
    templateUrl: "./new-dwelling-lists.component.html",
    styleUrl: "./new-dwelling-lists.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewDwellingListsComponent {
    private readonly rightSidebarService = inject(RightSidebarService);
    private readonly exportService = inject(NewDwellingListExportService);

    projects = input<IProjectStageDto[]>([]);

    numberOfProjects = computed(() => this.projects()?.length ?? 0);
    isExporting = this.exportService.isExporting;

    exportToExcel(): void {
        this.exportService.exportProjectsToExcel(this.projects());
    }

    onCloseSideBar(): void {
        this.rightSidebarService.toggleSidebarVisibility(RightSidebarOptions.Closed);
    }
}
